/**
 * GSAP animations for hhm-contact-poster: two-column staggered reveal on scroll.
 */
(function () {
	'use strict';

	function init() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
		gsap.registerPlugin(ScrollTrigger);

		const section = document.querySelector('.hhm-contact-poster-section');
		if (!section) return;

		const easeSnappy = 'power2.out';
		const easeBack = 'back.out(1.08)';

		// Left column: heading, list, location — stagger
		const left = section.querySelector('.hhm-contact-poster__left');
		if (left) {
			const heading = left.querySelector('.hhm-contact-poster__heading');
			const list = left.querySelector('.hhm-contact-poster__list');
			const location = left.querySelector('.hhm-contact-poster__location');
			const leftEls = [heading, list, location].filter(Boolean);
			if (leftEls.length) {
				gsap.set(leftEls, { opacity: 0, x: -24 });
				gsap.to(leftEls, {
					opacity: 1,
					x: 0,
					duration: 0.6,
					stagger: 0.12,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: left,
						start: 'top 85%',
						toggleActions: 'play none none none',
					},
				});
			}
		}

		// Right column: sticker (optional), figure, consultant block, email
		const right = section.querySelector('.hhm-contact-poster__right');
		if (right) {
			const sticker = right.querySelector('.hhm-contact-poster__sticker');
			const figure = right.querySelector('.hhm-contact-poster__figure');
			const consultant = right.querySelector('.hhm-contact-poster__consultant');
			const emailWrap = right.querySelector('.hhm-contact-poster__email-wrap');

			if (figure) {
				const img = figure.querySelector('img');
				if (img) {
					gsap.set(img, { opacity: 0, scale: 0.92 });
					gsap.to(img, {
						opacity: 1,
						scale: 1,
						duration: 0.75,
						ease: easeBack,
						scrollTrigger: {
							trigger: figure,
							start: 'top 88%',
							toggleActions: 'play none none none',
						},
					});
				}
			}

			const rightContent = [sticker, consultant, emailWrap].filter(Boolean);
			if (rightContent.length) {
				gsap.set(rightContent, { opacity: 0, y: 20 });
				gsap.to(rightContent, {
					opacity: 1,
					y: 0,
					duration: 0.55,
					stagger: 0.1,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: right,
						start: 'top 85%',
						toggleActions: 'play none none none',
					},
				});
			}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
